import { Extension } from "@tiptap/core";
import { Plugin } from "prosemirror-state";
import markdownIt from "markdown-it";
import DOMPurify from "dompurify";
import { ensureStyleHook } from "../hooks/useMarkdownIt";

const PasteHandler = Extension.create({
  name: "pasteHandler",

  addProseMirrorPlugins() {
    const editor = this.editor;
    const md = markdownIt({ html: true });
    ensureStyleHook();

    return [
      new Plugin({
        props: {
          handlePaste: (_, event) => {
            // If there's HTML content, let TipTap handle it natively
            const html = event.clipboardData?.getData("text/html");
            if (html) return false;

            const text = event.clipboardData?.getData("text/plain");
            if (!text) return false;

            if (/\n{3,}/.test(text) || /<br\s*\/?>/i.test(text)) {
              // First, convert any existing <br> tags to newlines
              const normalized = text.replace(/<br\s*\/?>/gi, "\n");

              const parts = normalized.split(/(\n{2,})/);

              const htmlParts: string[] = [];
              let pendingBreaks = 0;

              for (const part of parts) {
                if (/^\n+$/.test(part)) {
                  pendingBreaks = Math.max(0, part.length - 2);
                } else if (part.trim()) {
                  const rendered = md.render(part).trim();
                  const withBreaks =
                    pendingBreaks > 0
                      ? rendered.replace(/^<(p|h[1-6])>/, `<$1>${"<br>".repeat(pendingBreaks)}`)
                      : rendered;
                  htmlParts.push(withBreaks);
                  pendingBreaks = 0;
                }
              }

              const finalHtml = DOMPurify.sanitize(htmlParts.join("\n"), { ADD_ATTR: ["style"] });

              editor
                .chain()
                .deleteSelection()
                .insertContent(finalHtml, {
                  parseOptions: { preserveWhitespace: true },
                })
                .run();

              return true;
            }
            return false;
          },
        },
      }),
    ];
  },
});

export default PasteHandler;
